/*
    Show all the devices associated with the User
*/


import React, {useEffect} from 'react';
import { Tabs, Tab } from '@mui/material';

const DeviceTabs = ({ devices, selectedDevice, onDeviceSelect }) => {
    
    useEffect(()=>{
    })
    
    return (
        <Tabs
            value={selectedDevice?.MIRA_device_id}
            onChange={(event, newValue) => {
                const selectedDeviceData = devices.find(device => device.MIRA_device_id === newValue);
                onDeviceSelect(selectedDeviceData); 
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="device tabs"
            sx={{
                marginTop:'0',
                marginLeft: '20px',
                backgroundColor:'black',
            }}
        >
            {devices.map((device, index) => (
                <Tab key={index} label={device.device_name} value={device.MIRA_device_id}
                    sx={{
                        color: 'white',
                        marginRight:'45px'
                        }}
                />
            ))}
        </Tabs>
    );
};

export default DeviceTabs;
